import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        headerColor: 'white',

        casestudies : [],

        currentCasestudy : 0,
    },
    mutations: {
        updateHeaderColor(state, value) {
            state.headerColor = value;
        },

        updateCaseStudies(state, value) {
            state.casestudies = value;
        },

        updateCurrentCasestudy(state, value) {
            state.currentCasestudy = value;
        }
    },
    actions: {}
});
